/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".institucional-rodape[_ngcontent-%COMP%]{padding:0;list-style:none}.institucional-rodape[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#444}.open[_nghost-%COMP%]   ul[_ngcontent-%COMP%], .open   [_nghost-%COMP%]   ul[_ngcontent-%COMP%]{display:block}"];
export { styles as styles };
